<template>
  <router-view class="font-size-sm" />
</template>

<script>
export default {
  name: 'Conversations',
};
</script>
